import { v4 as uuidv4 } from "uuid";

import { ChatMessage } from "../api/models";

// Parses a backend timestamp into a Date. The backend may emit UTC without a
// timezone marker ("2025-09-30T12:36:53.179194"), in which case we append "Z".
// Strings that already carry a timezone (trailing "Z" or an offset like
// "+00:00") are parsed as-is. Returns null for empty/invalid input.
export const parseBackendDate = (dateString?: string): Date | null => {
  if (!dateString) return null;
  const hasTz =
    dateString.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(dateString);
  const normalized = hasTz ? dateString : dateString + "Z";
  const date = new Date(normalized);
  return isNaN(date.getTime()) ? null : date;
};

// Helper function to format dates with proper timezone handling
export const formatMessageDate = (dateString: string): string => {
  const date = parseBackendDate(dateString);

  // Check if the date is invalid
  if (!date) {
    console.warn("Invalid date string:", dateString);
    return "Invalid Date";
  }

  // Convert to local timezone and format
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZoneName: "short",
  });
};

export const createErrorMessage = (error: string): ChatMessage => ({
  role: "error",
  content: error,
  id: uuidv4(),
  date: new Date().toISOString(),
});

export const parseToolContent = (content: any) => {
  try {
    return typeof content === "string" ? JSON.parse(content) : content;
  } catch (e) {
    console.error("Failed to parse tool content:", e);
    return {};
  }
};
